import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "id", "timezone", "variant", "labelledById"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import useUniqueId from 'hooks/useUniqueId';
import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';
import getSelectableTimes from 'utils/times/getSelectableTimes';
import Flex, { Box } from 'components/Flex';
import { Select, Option } from 'components/Select';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TimePicker(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    timezone = _ref.timezone,
    variant = _ref.variant,
    labelledById = _ref.labelledById,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var uniqueId = useUniqueId();
  var timezoneId = "".concat(uniqueId, "-timezone");

  // Remove the seconds (if present), as these cannot be displayed in the time picker
  var timeInHourAndMinutes = "".concat(value === null || value === void 0 ? void 0 : value.split(':')[0], ":").concat(value === null || value === void 0 ? void 0 : value.split(':')[1]);
  return /*#__PURE__*/_jsxs(Flex, {
    wrap: true,
    align: "center",
    children: [/*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
      id: id,
      menuPositionFixed: false,
      labelledById: labelledById,
      "aria-describedby": timezoneId,
      value: timeInHourAndMinutes,
      onChange: onChange,
      variant: variant,
      mr: "xxs"
    }, otherProps), {}, {
      children: getSelectableTimes(getUsersISOLocale()).map(function (time) {
        return /*#__PURE__*/_jsx(Option, {
          value: time.value,
          children: time.label
        }, time.value);
      })
    })), timezone && /*#__PURE__*/_jsx(Box, {
      id: timezoneId,
      fontSize: "s",
      children: timezone
    })]
  });
}
export default TimePicker;